import Layout from '@/layout'

const OMSRouter = {
  path: '/OMS',
  component: Layout,
  redirect: 'noredirect',
  name: 'OMS',
  meta: {
    title: 'OMS',
    icon: 'daohang-ziliaoguanli',
    roles: []
  },
  children: [
    {
      path: 'Order',
      component: () => import('@/views/cargo/v0/OMS/order'),
      name: 'Order',
      meta: { title: 'order' },
      roles: ['module_OrderManagement']
    },
    {
      path: 'Warehousing',
      component: () => import('@/views/cargo/v0/OMS/warehousing'),
      name: 'Warehousing',
      meta: { title: 'warehousing' },
      roles: ['module_WarehousingManage']
    }/* ,
    {
      path: 'Inventory',
      component: () => import('@/views/cargo/v0/OMS/inventory'),
      name: 'Inventory',
      meta: { title: 'inventory' },
      roles: []
    } */
  ]
}

export default OMSRouter
